










import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import PNotification from '@/components/PNotification.vue';

@Component({
  components: {
    ConfirmDialog,
    PNotification
  }
})
export default class App extends Vue {

}
